import 'css-chunksrc/client/scenes/optimizedGantt/scroll/scrollBar/styles.scss';export default {
  "scrollBar": "_scrollBar_neiio_1",
  "horizontal": "_horizontal_neiio_10",
  "content": "_content_neiio_13",
  "track": "_track_neiio_19",
  "thumb": "_thumb_neiio_27",
  "visibleThumb": "_visibleThumb_neiio_30",
  "vertical": "_vertical_neiio_37",
  "noScroll": "_noScroll_neiio_82",
  "dragging": "_dragging_neiio_92"
};